const ACC_HIGH_RISK_SPORT_COVERAGE = 'ACCHighRiskSportCov';
const ACC_IMMEDIATE_COMPENSATION_COVERAGE = 'ACCImmediateCompensationCov';
const ACC_DEATH_COVERAGE = 'ACCDeathCov';
const TRA_CANCELLATION_COV = 'TRATopCancellationCov';
const TRA_SKIING_COV = 'TRATopSkiingCov';
const PET_HEATH_COVERAGE = 'PETHealthCov';
const PET_HEATH_PLUS_COVERAGE = 'PETHealthPlusCov';
const PET_LIFE_COVERAGE = 'PETLifeCov';

export {
    ACC_HIGH_RISK_SPORT_COVERAGE,
    ACC_IMMEDIATE_COMPENSATION_COVERAGE,
    ACC_DEATH_COVERAGE,
    TRA_CANCELLATION_COV,
    TRA_SKIING_COV,
    PET_HEATH_COVERAGE,
    PET_HEATH_PLUS_COVERAGE,
    PET_LIFE_COVERAGE
};
